var Confirm = (function() {
	var __private = {
		listener(input, div, conf) {
			if(input instanceof HTMLInputElement && div instanceof HTMLElement) {
				let value = input.value;

				document.addEventListener("keyup", function() {
					if(input.value === value) {
						div.style.display = "block";

						if(conf && conf instanceof HTMLElement) conf.style.display = "none";
					} else {
						div.style.display = "none";

						if(conf && conf instanceof HTMLElement) conf.style.display = "block";
					}
				});
			}
		}
	};

	return {
		init(input, div, conf) {
			__private.listener(input, div, conf);
		}
	};
})();

(function() {
	document.addEventListener("DOMContentLoaded", function() {
		// phone
		var phoneInput = document.getElementById("phoneNumber");
		var phoneMessg = document.getElementById("isPhoneConfirmed");

		// email
		var emailInput = document.getElementById("emailAddress");
		var emailMessg = document.getElementById("isEmailConfirmed");
		var emailConfr = document.getElementById("EmailConfirmed");

		// run script
		Confirm.init(phoneInput, phoneMessg);
		Confirm.init(emailInput, emailMessg, emailConfr);
	});
})();